import { render, staticRenderFns } from "./DiscountSetting.vue?vue&type=template&id=1e2a3a64"
import script from "./DiscountSetting.vue?vue&type=script&lang=js"
export * from "./DiscountSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports